// extracted by mini-css-extract-plugin
export default {"container":"infoBoxes_container__3m3H8","box":"infoBoxes_box__cTVAV","content__box":"infoBoxes_content__box__x+gng","content__text":"infoBoxes_content__text__g0YfU"};